import { useState, useCallback } from 'react';

const KEY = 'formoprop_favoritos';

function leerStorage() {
  try { return JSON.parse(localStorage.getItem(KEY) || '[]'); }
  catch { return []; }
}

export default function useFavoritos() {
  const [ids, setIds] = useState(leerStorage);

  const toggle = useCallback((id) => {
    setIds(prev => {
      const next = prev.includes(id) ? prev.filter(x => x !== id) : [...prev, id];
      localStorage.setItem(KEY, JSON.stringify(next));
      return next;
    });
  }, []);

  const esFavorito = useCallback((id) => ids.includes(id), [ids]);

  return { ids, toggle, esFavorito, cantidad: ids.length };
}
